import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/users/getUserActions";
import * as clientActions from "../../actions/clients/getClientActions";
import { bindActionCreators } from "redux";
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg"
import { createNotification, NOTIFICATION_TYPE_SUCCESS } from 'react-redux-notify';
import { Card, CardContent, CardHeader, Image, Checkbox, Message } from "semantic-ui-react";
import { PLATFORM_SETTINGS_URL, PLATFORM_DATAMANAGEMENT_URL, PLATFORM_DATAENTITIES_URL, PLATFORM_TOKEN_STATUS_URL,WS_WF_MIGRATION_URL } from "../../Constants/routes";


try {

    var userDetails = atob(localStorage.getItem("userDetails"));
    if (userDetails) {
        userDetails = JSON.parse(userDetails);
    }
} catch (e) {
    window.location.reload();
}
var FIRM_ID = null;
FIRM_ID = userDetails.UserContext.firmId;

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectCount: 0,
            exportTOExcel: 0,
            subHeaderItems: [],
            documentCheckBox: true,
            isTokenGrantedAndValid: null
        };
        this.documentBoxChange = this.documentBoxChange.bind(this);
    }

    documentBoxChange() {
        this.setState({
            documentCheckBox: !this.state.documentCheckBox
        });
    }

    toggleBulkEditForm() {
        this.setState({
            shouldModalOpen: !this.state.shouldModalOpen
        });
    }

    componentDidMount() {
        this.IntegrationPhase = this.props.actions.fetchIntegrationPhData(FIRM_ID);
        this.clientLookUpData = this.props.clientActions.getClientLookupData(FIRM_ID);
        this.documentSyncLookUpData = this.props.clientActions.getFirmDocumentSync(FIRM_ID);
        this.getTokenValidity().then((isTokenGrantedAndValid) => {
            this.setState({
                isTokenGrantedAndValid: isTokenGrantedAndValid
            });
        });
        this.gracePeriodData = this.props.actions.getFirmGracePeriodDetails(FIRM_ID);
        this.LicenseData = this.props.actions.fetchLicenseDetails();
    }

    RedirectPlatformApp = () => {
        window.open(PLATFORM_SETTINGS_URL);
    };

    RedirectPlatformDataManagement = () => {
        window.open(PLATFORM_DATAMANAGEMENT_URL);
    };

    RedirectPlatformDataEntities = () => {
        window.open(PLATFORM_DATAENTITIES_URL);
    };

    getTokenValidity = () => {
        return fetch(PLATFORM_TOKEN_STATUS_URL,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            }).then(response => {
                return response.json();
            }).then((json) => {
                try {
                    const obj = JSON.parse(json.Data);
                    return obj.IsTokenGrantedAndValid;
                }
                catch (e) {
                    console.error('Invalid JSON input:', e.message);
                    window.location.href = "/webapp/notauth";
                    return;
                }
            })
            .catch(error => {
                console.log(error)
            })
    };

    RedirectWorkstreamMigrationPage = () => {
        window.open(WS_WF_MIGRATION_URL,"_self");
    };

    render() {
        return (
            <Fragment>
                <div class="p-8 wk-sub-header">
                    <span className="m-10">CCH Axcess<sup class="fs-10">TM</sup> Workflow Integration</span>
                </div>
                <p class="m-10 ml-16">
                    CCH Axcess Workflow integrates with your CCH Axcess staff data and credentials, client data, and other CCH Axcess products
                    such as CCH Axcess Tax and CCH Axcess Document.<br />
                    For additional information about the integration click <a href="https://support.cch.com/kb/solution/000135883/000135883" target="_blank">here.</a>
                </p>
                <div className="cards-inline" >
                    <Card className="ml-16 mt-16 text-align-left card-medium">
                        <CardHeader className="m-10 mt-16 bold">Staff Linking</CardHeader>
                        <Image className="ml-10 mr-10" src={require('../../static/media/staff_linking.svg')} />
                        <div class="m-10 p-relative h-100" >
                            <div class="d-inline-block"><strong class="fs-30">{this.props.IntegrationPhase ? this.props.IntegrationPhase.numberOfDays : 1}</strong>
                            </div>
                            <div class="ml-10 d-inline-block w-75per">
                                days remaining to link users.
                            </div>
                            <div className="p-absolute bottom-0">
                                {this.props.IntegrationPhase ? this.props.IntegrationPhase.linkedUserCount : 0} of {this.props.IntegrationPhase ? this.props.IntegrationPhase.totalUserCount : 0} users linked
                            </div>
                        </div>
                        <div class="bg-wk-primary-gray-tint6 p-6">
                            <svg className="svg_icon xcm-icon-alert-circle size-24 color-wk-primary-red">
                                <use xlinkHref={`${svg_icon_path}#xcm-icon-alert-circle`} />
                            </svg>
                            <a href="stafflinkingindex/"><u><strong id="dtNotlinked" class="fs-16">{this.props.IntegrationPhase ? this.props.IntegrationPhase.notLinkedUserCount : 0}
                            </strong></u></a> users to be linked
                        </div>
                    </Card>
                    <Card className="ml-16 mt-16 text-align-left card-medium">
                        <CardHeader className="m-10 mt-16 bold"><a onClick={this.RedirectPlatformDataEntities}><u>Client Linking</u></a></CardHeader>
                        <Image className="ml-10 mr-10" src={require('../../static/media/client_linking.svg')} />

                        <div>
                            <div class="m-10 p-relative h-100">
                                Link Workflow Clients to CCH Axcess Clients based on Account Number (ClientID.SubID)
                                <div class="p-absolute bottom-0">
                                    {this.props.clientLookUpData.linkedClientCount} of {this.props.clientLookUpData.totalClientCount} clients linked
                                </div>
                            </div>
                            <div class="bg-wk-primary-gray-tint6 p-6">
                                <svg className="svg_icon xcm-icon-alert-circle size-24 color-wk-primary-red">
                                    <use xlinkHref={`${svg_icon_path}#xcm-icon-alert-circle`} />
                                </svg>
                                <a onClick={this.RedirectPlatformDataManagement}><u><strong class="fs-16">{this.props.clientLookUpData.unlinkedClientCount}</strong></u></a> clients to be linked
                            </div>
                        </div>
                    </Card>

                    <Card className="ml-16 text-align-left card-medium">
                        <CardHeader className="m-10 mt-16 bold">
                            <div><a onClick={this.RedirectPlatformApp}><u>Document Mapping</u></a>
                                <span data-tooltip="Click on the Document Mapping hyperlink to review mappings." class="float-right">
                                    <svg class="svg_icon xcm-icon-info size-24 text-align-right color-yellow">
                                        <use xlinkHref={`${svg_icon_path}#xcm-icon-info`} />
                                    </svg>
                                </span>
                            </div>
                        </CardHeader>
                        <Image className="ml-10 mr-10" src={require('../../static/media/document_mapping.svg')} />
                        <div class="m-10 d-inline-block h-100 oy-auto">
                            Map Workflow Categories and Task Types to CCH Axcess Document Classes and Subclasses to automatically display linked files on the Control Sheet
                        </div>
                        <div class="bg-wk-primary-gray-tint6 p-8 cards-inline">
                            <text className="ml-2">Document Sync {this.props.documentSyncLookUpData.DocumentSync} </text>
                        </div>
                    </Card>

                    <Card className="ml-16 text-align-left card-medium">
                        <CardHeader className="m-10 mt-16 bold">Manage Tax Returns</CardHeader>
                        <Image className="ml-10 mr-10" src={require('../../static/media/tax_integration.svg')} />
                        <div class="m-10 d-inline-block h-100 oy-auto">
                            Link CCH Axcess Tax Returns to the Control Sheet, so you can easily track the return's status, open the return, and preview the return's e-file status
                        </div>
                        <div class="bg-wk-primary-gray-tint6 p-6">
                            <svg className="svg_icon xcm-icon-alert-circle size-24 color-wk-primary-red">
                                <use xlinkHref={`${svg_icon_path}#xcm-icon-alert-circle`} />
                            </svg>
                            <a href="taxintegrated">Tax Tasks to be linked</a>
                        </div>
                    </Card>

                    <Card className="ml-16 text-align-left card-medium">
                        <CardHeader className="m-10 mt-16 bold"><a onClick={this.RedirectPlatformApp}><u>Practice (Time) Integration</u></a></CardHeader>
                        <Image className="ml-10 mr-10" src={require('../../static/media/practice_time_integration.svg')} />
                        <div class="m-10 d-inline-block h-100">
                            Populate the Task with the actual hours that have been entered into CCH Axcess<sup class="fs-10">TM</sup> Time Capture.
                        </div>
                        <div className="bg-wk-primary-blue-tint3 text-align-center p-8">
                            <text className="color-white">Upcoming</text>{/*<button className="ui primary button disabled w-200">Upcoming</button>*/}
                        </div>
                    </Card>
                </div>
                <div className="cards-inline" >
                    <Card className="ml-16 mt-16 text-align-left card-medium">
                        <CardHeader className="m-10 mt-16 bold">Workstream Migration</CardHeader>
                        <Image className="ml-10 mr-10" src={require('../../static/media/Migration_Icon.svg')} />
                        <div class="m-10 p-relative h-100" >
                            <ul>
                                <li>Firm Mapping data</li>
                                <li>Type/Template Mappings</li>
                                <li>Project Batch selection(s)</li>
                            </ul>
                        </div>
                        {(this.props.gracePeriodData.axcessIntegrationEnabled && this.props.gracePeriodData.isFirmLinkedToAxcess && this.props.gracePeriodData.axcessIntegrationDate != null && this.props.LicenseData) ?
                            <div className="bg-wk-primary-blue text-align-center p-8" onClick={this.RedirectWorkstreamMigrationPage}>
                                <text className="color-white">Start Migration</text>
                            </div> :
                            <div className="bg-wk-primary-blue-tint3 text-align-center p-8">
                                <text className="color-white">Start Migration</text>
                            </div>
                        }
                       
                    </Card>
                </div>
                {
                    this.state.isTokenGrantedAndValid !== null && !this.state.isTokenGrantedAndValid ?
                        <p>
                            <div className="m-10 mr-55 pr-10">
                                <Message warning className="mr-50">
                                    The authorization for your synchronization has been unexpectedly terminated or revoked. The sync will not run until it has been re-established. Please review the Sync Authorization Utility to reauthenticate.
                                </Message>
                            </div>
                        </p>
                        :
                        <div></div>
                }
            </Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        isModalOpen: state.userReducer.isModalOpen,
        staffReportDetails: state.userReducer.staffReportDetails,
        IntegrationPhase: state.userReducer.IntegrationPhaseData,
        gracePeriodData: state.userReducer.firmGracePeriodData,
        clientLookUpData: state.clientReducer.clientLookUpDetails,
        documentSyncLookUpData: state.clientReducer.documentSyncLookUpDetails,
        LicenseData: state.userReducer.isLicenseExists
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    clientActions: bindActionCreators(clientActions, dispatch),
    createNotification: (config) => {
        dispatch(createNotification(config))
    },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);
